import { ReactNode } from "react";
import { Paper, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EnergyChartItem } from "../ChangeEmissionTab/data/mappersVehiclesFuels";
import EnergyIntensityBubbleChart from "../EnergyIntensityBubbleChart";
import VehicleCategoryTotalsBarChart from "../VehicleCategoryTotalsBarChart";

interface EffectEnergyCardProps {
	title: string;
	text: string;
	deltaCard?: ReactNode;
	circleChartTitle: string;
	yAxisTitle: string;
	chartData: EnergyChartItem[];
	barChartTitle: string;
	isLoading?: boolean;
}

export const EffectEnergyCard = ({
	title,
	text,
	deltaCard,
	circleChartTitle,
	yAxisTitle,
	chartData,
	barChartTitle,
	isLoading,
}: EffectEnergyCardProps) => {
	const { t } = useTranslation("whatif.rootcause");

	if (isLoading) {
		return <Skeleton variant="rounded" height={400} width="100%" />;
	}

	return (
		<Paper elevation={0} sx={{ p: 2, height: "100%" }}>
			<Stack gap={2}>
				<Stack gap={1}>
					<Typography variant="h6">{title}</Typography>

					<Typography variant="body2" color="text.secondary">
						{text}
					</Typography>
				</Stack>

				{deltaCard}

				<EnergyIntensityBubbleChart
					title={circleChartTitle}
					data={chartData}
					baselineLabel={t("root cause results/changes in emissions/chart labels/baseline")}
					comparisonLabel={t("root cause results/changes in emissions/chart labels/comparison")}
					yAxisTitle={yAxisTitle}
					xAxisTitle={t(
						"root cause results/changes in emissions/chart labels/tonne-km share axis"
					)}
				/>

				<VehicleCategoryTotalsBarChart
					title={barChartTitle}
					data={chartData}
					baselineLabel={t("root cause results/changes in emissions/chart labels/baseline")}
					comparisonLabel={t("root cause results/changes in emissions/chart labels/comparison")}
					legendTitle={t(
						"root cause results/changes in emissions/chart labels/tonne-km share axis"
					)}
				/>
			</Stack>
		</Paper>
	);
};
